import { Controller } from '@hotwired/stimulus';
/*
 * Description
 * -------
 *
 * Validates text input against a predefined keyword and enables/disables submit element.
 *
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Targets
 * -------
 *
 * input  - (required) - text input to validate
 * submit - (required) - submit button/link to enable/disable
 *
 * Values
 * -------
 *
 * keyword - (required) - keyword to match from text input
 *
 * Usage
 * -------
 *
 * <div
 *   data-controller="submit-enabler"
 *   data-submit-enabler-keyword-value="DELETE"
 * >
 *   <input
 *     data-submit-enabler-target="input"
 *     data-action="input->submit-enabler#validate"
 *   >
 *   <button data-submit-enabler-target="submit" disabled>Submit</button>
 * </div>
 */
export class SubmitEnabler extends Controller {
    static targets = ['input', 'submit'];
    static values = { keyword: String };
    validate() {
        const inputValue = this.inputTarget.value.trim();
        const isMatch = inputValue.toLowerCase() === this.keywordValue.toLowerCase();
        isMatch ? this.enableSubmit() : this.disableSubmit();
    }
    enableSubmit() {
        if (this.submitTarget instanceof HTMLButtonElement) {
            this.submitTarget.disabled = false;
        }
        if (this.submitTarget instanceof HTMLAnchorElement) {
            this.submitTarget.classList.remove('disabled');
        }
    }
    disableSubmit() {
        if (this.submitTarget instanceof HTMLButtonElement) {
            this.submitTarget.disabled = true;
        }
        if (this.submitTarget instanceof HTMLAnchorElement) {
            this.submitTarget.classList.add('disabled');
        }
    }
}
